
import ToastService from '@/components/toast/toast-service';
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import { ModalSlotName } from '@/ui-kit/components/modal/enums';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Veriff from '@/components/veriff';

export default {
  name: 'VerificationModal',
  components: {
    ModalWindow,
    Typography,
    Veriff,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      ModalSlotName,
      TypographyType,
    };
  },
  computed: {
    message() {
      return this.modalData.message;
    },
    user() {
      return this.modalData.user;
    },
  },
  methods: {
    handleVerification(isVerified) {
      if (isVerified) {
        ToastService.openPositive('Your identity was successfully verified');
      } else {
        ToastService.openNegative('Whoops! Weren\'t able to verify your identity. Please try again.');
      }

      this.closeHandler(isVerified);
    },
  },
};
